import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser} from "@angular/common";

@Injectable({
  providedIn: 'root'
})
export class NavbarService {

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  navbarInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      document.getElementById('navbar').classList.add('navbar-light');
      document.getElementById('logo2').style.display = 'block';
      document.getElementById('logo1').style.display = 'none';
      document.getElementById('about').classList.add('text-dark');
      document.getElementById('navbarProducts').classList.add('text-dark');
      document.getElementById('navbarServices').classList.add('text-dark');
      document.getElementById('navbarContacts').classList.add('text-dark');
      document.getElementById('blog').classList.add('text-dark');
      document.getElementById('ponuka').classList.add('text-dark');
    }
  }

  navbarDestroy(): void {
    if (isPlatformBrowser(this.platformId)) {
      document.getElementById('navbar').classList.remove('navbar-light');
      document.getElementById('logo2').style.display = 'none';
      document.getElementById('logo1').style.display = 'block';
      document.getElementById('about').classList.remove('text-dark');
      document.getElementById('navbarProducts').classList.remove('text-dark');
      document.getElementById('navbarServices').classList.remove('text-dark');
      document.getElementById('navbarContacts').classList.remove('text-dark');
      document.getElementById('blog').classList.remove('text-dark');
      document.getElementById('ponuka').classList.remove('text-dark');
    }
  }
}
